<template>
  <section v-if="calendar?.deposit_snapshot" class="border rounded p-3 my-3">
    <h6>Sinal do agendamento</h6>
    <div class="row g-2">
      <div class="col-sm-6">Sinal exigido: <strong>{{ money(calendar.deposit_snapshot.required_amount) }}</strong></div>
      <div class="col-sm-6">Identificado nos comprovantes: <strong>{{ money(current.advance_amount) }}</strong></div>
      <div class="col-sm-6">Falta para o sinal: <strong>{{ money(Math.max(0, Number(calendar.deposit_snapshot.required_amount) - Number(current.advance_amount || 0))) }}</strong></div>
      <div class="col-sm-6">Saldo estimado do serviço: <strong>{{ money(Math.max(0, Number(calendar.deposit_snapshot.service_price || calendar.base_price || 0) - Number(current.advance_amount || 0))) }}</strong></div>
    </div>
    <p class="small text-muted mt-2">{{ statusLabel(current.deposit_status) }}. Valores reconhecidos em documentos, sem confirmação bancária.</p>
    <p class="small">Pix: {{ calendar.deposit_snapshot.pix_key }} — {{ calendar.deposit_snapshot.holder }}</p>
    <button type="button" class="btn btn-sm btn-outline-primary mb-2" :disabled="loading" @click="load">{{ loading ? 'Carregando...' : 'Atualizar comprovantes' }}</button>
    <p v-if="error" class="text-danger small" role="alert">{{ error }}</p>
    <ul v-if="receipts.length" class="list-unstyled">
      <li v-for="receipt in receipts" :key="receipt.id" class="border-top py-2">
        <span>{{ statusLabel(receipt.status) }} · {{ money(receipt.accepted_amount) }}</span>
        <small class="d-block text-muted">{{ new Date(receipt.created_at).toLocaleString('pt-BR') }}</small>
        <button v-if="receipt.file_available" type="button" class="btn btn-link btn-sm" @click="download(receipt)">Baixar comprovante</button>
        <button v-if="receipt.status === 'technical_error'" type="button" class="btn btn-link btn-sm" @click="retry(receipt)">Tentar análise novamente</button>
      </li>
    </ul>
    <p v-else-if="!loading" class="small text-muted">Nenhum comprovante recebido.</p>
  </section>
</template>

<script>
import api from '../../config/axios.js';
export default {
  name: 'DepositDetails',
  props: { calendar: { type: Object, default: null } },
  data() { return { current: {}, receipts: [], loading: false, error: '', requestId: 0 }; },
  watch: { 'calendar.id': { immediate: true, handler() { this.current = this.calendar || {}; this.receipts = []; this.error = ''; this.load(); } } },
  methods: {
    money(value) { return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(Number(value || 0)); },
    statusLabel(status) { return ({ not_required: 'Sem sinal', pending: 'Pendente', registered: 'Recebido, aguardando processamento', abandoned: 'Escolha do agendamento não concluída', partial: 'Parcial', sufficient: 'Sinal suficiente', accepted: 'Aceito', invalid: 'Inválido', duplicate: 'Repetido', processing: 'Em análise', technical_error: 'Falha técnica', awaiting_upload: 'Aguardando arquivo', cancelled: 'Agendamento cancelado' })[status] || status; },
    async load() {
      const token = ++this.requestId;
      if (!this.calendar?.deposit_snapshot) { this.loading = false; return; }
      this.loading = true; this.error = '';
      try {
        const { data } = await api.axios.get(`/api/calendar/${this.calendar.id}/deposit`);
        if (token === this.requestId) { this.current = data.calendar; this.receipts = data.receipts; }
      } catch { if (token === this.requestId) this.error = 'Não foi possível carregar os comprovantes.'; }
      finally { if (token === this.requestId) this.loading = false; }
    },
    async download(receipt) {
      try {
        const response = await api.axios.get(`/api/calendar/${this.calendar.id}/deposit/receipts/${receipt.id}`, { responseType: 'blob' });
        const url = URL.createObjectURL(response.data); const anchor = document.createElement('a');
        const extension = ({ 'application/pdf': 'pdf', 'image/jpeg': 'jpg', 'image/png': 'png', 'image/webp': 'webp' })[receipt.mime_type] || 'bin';
        anchor.href = url; anchor.download = `comprovante-${receipt.id}.${extension}`; anchor.click(); setTimeout(() => URL.revokeObjectURL(url), 1000);
      } catch { this.error = 'Arquivo indisponível ou acesso não permitido.'; }
    },
    async retry(receipt) {
      try { await api.axios.post(`/api/calendar/${this.calendar.id}/deposit/receipts/${receipt.id}/retry`); await this.load(); }
      catch { this.error = 'Não foi possível solicitar uma nova análise.'; }
    },
  },
};
</script>
